import request from '@/utils/request'

// 获取所有员工
export function getAllStaffs() {
  return request({
    url: process.env.VUE_APP_ACCESS_API + '/api/users/',
    method: 'get'
  })
}
